import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

export const Sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

@Pipe({
    name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {
    transform(value: number, numberFormat: string): string {
        const numberPipe = new DecimalPipe('en-GB');
        let count = 0;
        while (value > 1024) {
            value = value / 1024;
            count++;
        }
        return `${numberPipe.transform(value, numberFormat)} ${Sizes[count]}`;
    }
}
